import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import { CONFIG_TIMELINE_PURGE_DAYS } from 'core/common/constants/env'

dayjs.extend(isBetween)
dayjs.extend(localizedFormat)
dayjs.extend(timezone)
dayjs.extend(utc)

const timeZone = dayjs.tz.guess()

export function formatDate(lastUpdate, format = 'LL') {
  return lastUpdate ? dayjs.utc(lastUpdate).tz(timeZone).format(format) : ''
}

export function inFreezing(dateStart, dateEnd) {
  return dayjs().tz('America/Sao_Paulo').isBetween(dateStart, dayjs(dateEnd))
}

export function getTimelinePurgeDate() {
  if (!CONFIG_TIMELINE_PURGE_DAYS) {
    return undefined
  }

  const date = new Date()
  date.setDate(date.getDate() - CONFIG_TIMELINE_PURGE_DAYS)
  return formatDate(date)
}

export function isToday(date) {
  const today = new Date()

  if (today.toDateString() === date.toDateString()) {
    return true
  }

  return false
}
